// Reducers
import { combineReducers } from 'redux';
import { reducer as oidcReducer } from 'redux-oidc';
import { connectRouter } from 'connected-react-router';
import bootComplete from './bootComplete';
import carrier from './carrier';
import client from './client';
import fontSizeOverride from './fontSizeOverride';
import features from './features';
import iFrameId from './iFrameId';
import supportedLanguage from './supportedLanguage';
import redesign from './redesign';
import theme from './theme';
import user from './user';
import comparePageScrolling from './comparePageScrolling';
import comparePageSetOrRemovePlans from './comparePageSetRemovePlans';

const reducers = history => combineReducers({
  bootComplete,
  carrier,
  client,
  comparePageScrolling,
  comparePageSetOrRemovePlans,
  features,
  fontSizeOverride,
  iFrameId,
  supportedLanguage,
  redesign,
  theme,
  user,
  auth: oidcReducer,
  router: connectRouter(history),
});

export default reducers;
